import { ElasticSearchFacetCounts } from 'types/commons';

import { EXCLUDED_FACET_KEYS } from 'constants/facets';

const filterKeys = (
  facet: ElasticSearchFacetCounts | undefined
): ElasticSearchFacetCounts =>
  Object.fromEntries(
    Object.entries(facet ?? {}).filter(
      ([key]) => !EXCLUDED_FACET_KEYS.includes(key)
    )
  );

const filterFacetKeys = <
  F extends Partial<Record<K, ElasticSearchFacetCounts | undefined>>,
  K extends string
>(
  facets: F,
  facetsAvailable: K[]
): Record<K, ElasticSearchFacetCounts> =>
  facetsAvailable.reduce(
    (acc, key) => {
      (acc as Record<K, ElasticSearchFacetCounts>)[key] = filterKeys(facets[key]);
      return acc;
    },
    {} as Record<K, ElasticSearchFacetCounts>
  );

export default filterFacetKeys;
